import useAppHooks from "../../../../../../shared/hooks/useAppHooks";
import {
  fetchExamQuestionRequest,
  setCurrentQuestionIndex,
  setActiveSection,
} from "../../../../../../redux/exam/examSlice";
import { normalizeExamQuestionStatus } from "../../../../../../shared/utilities/helpers/examQuestionStatus";
import "./QuestionGrid.css";

export default function QuestionGrid({ onSelect, registerRef }) {
  const { dispatch, selector } = useAppHooks();
  const { questionsData, testDetails, paperId, testType } = selector(
    (s) => s.examSlice
  );

  /* --------------------------------
     GROUP QUESTIONS BY SECTION
  -------------------------------- */
  const grouped = [];
  const map = {};

  questionsData.forEach((q) => {
    const key = `${q.subject} ${q.section_name || ""}`.trim();
    if (!map[key]) map[key] = [];
    map[key].push(q);
  });

  for (const key in map) {
    grouped.push({ section: key, questions: map[key] });
  }

  /* --------------------------------
     STATUS → CSS CLASS
  -------------------------------- */
  const getClassByStatus = (question) => {
    const status = normalizeExamQuestionStatus(question);
    switch (status) {
      case "answered":
        return "question-box answered";
      case "unanswered":
        return "question-box unanswered";
      case "marked":
        return "question-box marked";
      case "answered_marked":
        return "question-box answered-marked";
      case "current":
        return "question-box current";
      default:
        return "question-box not-visited";
    }
  };

  return (
    <div>
      {grouped.map((group, groupIdx) => (
        <div key={groupIdx} className="question-section">
          <h6 className="question-section-title">{group.section}</h6>

          <div className="question-grid">
            {group.questions.map((q, idx) => {
             
              const globalIndex = questionsData.findIndex(
                (ques) => ques.qid === q.qid
              );

              return (
                <div
                  key={q.qid}
                  ref={(el) => {
                    if (idx === 0 && registerRef) {
                      registerRef(group.section, el);
                    }
                  }}
                  className={getClassByStatus(q)}
                  onClick={() => {
                    dispatch(setActiveSection(group.section));
                    dispatch(setCurrentQuestionIndex(globalIndex));

                    dispatch(
                      fetchExamQuestionRequest({
                        paperId,
                        paperType: testDetails?.paper_type || testType?.id,
                        qid: q.qid,
                        testId: testDetails?.testId,
                      })
                    );

                    onSelect?.(q.qid);
                  }}
                >
                  
                  {globalIndex + 1}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
